
/*
 *   File : manage-category.js
 *   Author URI : https://evoqins.com
 *   Description : Modal component to create and edit categories in the application.
 *   Integrations : null
 *   Version : v1.1
 */

// Packages
import { useEffect, useState } from "react";
import { toast } from "react-toastify";

// Components
import { Icon } from "../Icon";
import { CustomTextArea, CustomTextInput1 } from "../FormElements";
import { PrimaryButton, SecondaryButton } from "../Buttons";

// Styles
import style from "../../Styles/Components/manage-category.module.scss";

// Services
import APIService from "../../Services/api-service";

const ManageCategory = (props) => {


    const [userCategory, setUserCategory] = useState("");
    const [userCategoryError, setUserCategoryError] = useState("");

    const [moreDetails, setMoreDetails] = useState("");
    const [moreDetailsError, setMoreDetailsError] = useState("");

    const [categoryId, setCategoryId] = useState(null);
    const [apiLoader, setApiLoader] = useState(false);

    useEffect(() => {
        if (props.data !== null) {
            setCategoryId(props.data.category_id);
            setUserCategory(props.data.category);
            setMoreDetails(props.data.description);
        }
    }, [props]);

    useEffect(() => {
        var my_modal = document.getElementById("add-user-category-modal");
        my_modal.addEventListener("hidden.bs.modal", () => {
            props.close();
            setUserCategory("");
            setMoreDetails("");
            setUserCategoryError("");
            setMoreDetailsError("");
        });
        //eslint-disable-next-line
    }, [props.close]);



    function _handleCategoryInput(value) {
        setUserCategory(value);
        setUserCategoryError("");
    }

    function _handleDetails(value) {
        setMoreDetails(value);
        setMoreDetailsError("");
    }



    function _handleValidation() {
        let valid = true;
        if (userCategory.length === 0) {
            setUserCategoryError("Enter category");
            valid = false;
        }
        if (moreDetails.length === 0) {
            setMoreDetailsError("Enter details");
            valid = false;
        }
        if (valid === true) {
            _addCategory();
        }
    }


    // API - add category type

    const _addCategory = () => {
        setApiLoader(true);
        const url = props.data === null ? "/quiz/add-category" : "/quiz/edit-category";

        const request = {
            "category_id": categoryId,
            "category": userCategory,
            "description": moreDetails
        }

        APIService(true, url, request).then((response) => {
            toast.dismiss()
            if (response.status_code === 200) {
                toast.success('Category type added', {
                    type: 'success'
                });
                document.getElementById("close-modal").dispatchEvent(new Event("click"));
                props.updateList()
            } else {
                toast.error(response.message, {
                    type: 'error'
                });
            }
            setApiLoader(false);
        });
    }

    return (
        <div className={`modal fade ${style.e_modal}`}
            id="add-user-category-modal"
            tabIndex="-1"
            aria-labelledby="add-user-category-modal"
            aria-hidden="true"
            data-bs-backdrop="true" >
            <div className={`modal-dialog position-relative modal-dialog-centered ${style.e_dialog}`}>
                <div className={`modal-content padding-24px-lr padding-32px-tb ${style.e_content} `}>
                    <div className="d-flex align-items-center justify-content-between mb-4 px-2">
                        <p className="e-montserrat-semi-bold e-font-16 e-line-height-24px mb-0">{props.data !== null ? "Update" : "Add new"} user category</p>
                        <Icon icon="close"
                            size={18}
                            id="close-modal"
                            data-bs-dismiss="modal"
                            className='cursor-pointer' />
                    </div>
                    <div className={` px-2`}>

                        <div className="row">
                            <div className="col-12 mb-2">
                                <CustomTextInput1 label="User category"
                                    type="text"
                                    postfix={"*"}
                                    error={userCategoryError}
                                    value={userCategory}
                                    placeHolder="Category"
                                    handleChange={_handleCategoryInput} />
                            </div>
                        </div>
                        <div className="row">
                            <div className="col-12 margin-32px-bottom">
                                <CustomTextArea label="More details"
                                    placeHolder="More details"
                                    id="Details"
                                    postfix="*"
                                    value={moreDetails}
                                    error={moreDetailsError}
                                    handleChange={_handleDetails} />
                            </div>
                        </div>
                    </div>
                    <div className="d-flex justify-content-end gap-16px">
                        <SecondaryButton label="Cancel"
                            cancel="modal"
                            className="padding-14px-tb padding-50px-lr" />
                        <PrimaryButton label={props.data !== null ? "Update" : "Add"}
                            disabled={apiLoader}
                            loader={apiLoader}
                            className="padding-14px-tb padding-60px-lr"
                            handleClick={_handleValidation} />
                    </div>
                </div>
            </div>
        </div>
    )
}

export default ManageCategory